(function () {
  'use strict';

  var cfg = window.BongioChatConfig || {};
  var API_URL = cfg.apiUrl || '';
  var isLoggedIn = cfg.isLoggedIn || false;
  var isAgent = cfg.isAgent === true;
  var customerName = cfg.customerName || '';
  // Firmato lato server dal tema (snippet bongio-chat-identity): è l'unica prova
  // di identità che il backend accetta per modalità agente e storico ordini.
  var identityToken = cfg.identityToken || '';
  var currentProductHandle = cfg.currentProductHandle || '';
  var currentCollectionHandle = cfg.currentCollectionHandle || '';

  var history = [];
  var isOpen = false;
  var isSending = false;
  var suggestionsShown = true;

  var PUBLIC_SUGGESTIONS = [
    'Mostrami le collezioni bagno',
    'Come funziona la spedizione?',
    'Qual è la differenza tra miscelatore e termostatico?'
  ];

  var TECHNICAL_SUGGESTIONS = [
    'Dimensioni e attacchi della serie attuale',
    'Compatibilità con impianti a bassa pressione',
    'Dove trovo i miei ordini recenti?'
  ];

  // Escape completo, virgolette incluse: il testo può finire anche dentro attributi HTML.
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function timeStr() {
    return new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  }

  function init() {
    createDOM();
    bindEvents();
  }

  function createDOM() {
    // Floating button
    var btn = document.createElement('button');
    btn.id = 'bongio-chat-btn';
    btn.setAttribute('aria-label', 'Apri assistente Bongio');
    btn.innerHTML =
      '<svg class="bongio-chat-icon" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z"/></svg>' +
      '<svg class="bongio-close-icon" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
    document.body.appendChild(btn);

    // Panel
    var panel = document.createElement('div');
    panel.id = 'bongio-chat-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Chat assistente Bongio');

    var title = isLoggedIn && customerName
      ? esc(customerName) + ', benvenuto'
      : 'Assistente Bongio';

    var badgeClass = isLoggedIn ? 'bongio-header-badge visible' : 'bongio-header-badge';

    panel.innerHTML =
      '<div class="bongio-header">' +
        '<span class="bongio-header-title">' + title + '</span>' +
        '<span class="' + badgeClass + '">Supporto Tecnico</span>' +
      '</div>' +
      '<div class="bongio-messages" id="bongio-messages">' +
        '<div class="bongio-typing" id="bongio-typing">' +
          '<div class="bongio-typing-dot"></div>' +
          '<div class="bongio-typing-dot"></div>' +
          '<div class="bongio-typing-dot"></div>' +
        '</div>' +
      '</div>' +
      '<div class="bongio-suggestions" id="bongio-suggestions"></div>' +
      '<div class="bongio-input-area">' +
        '<textarea class="bongio-input" id="bongio-input" rows="1" placeholder="Scrivi un messaggio..." aria-label="Messaggio"></textarea>' +
        '<button class="bongio-send-btn" id="bongio-send" aria-label="Invia">' +
          '<svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>' +
        '</button>' +
      '</div>';

    document.body.appendChild(panel);
    renderSuggestions();
  }

  function renderSuggestions() {
    var container = document.getElementById('bongio-suggestions');
    if (!container) return;

    var suggestions = isAgent ? TECHNICAL_SUGGESTIONS : PUBLIC_SUGGESTIONS;
    container.innerHTML = '';

    suggestions.forEach(function (text) {
      var btn = document.createElement('button');
      btn.className = 'bongio-suggestion-btn';
      btn.textContent = text;
      btn.addEventListener('click', function () {
        sendMessage(text);
      });
      container.appendChild(btn);
    });
  }

  function hideSuggestions() {
    if (!suggestionsShown) return;
    var el = document.getElementById('bongio-suggestions');
    if (el) el.style.display = 'none';
    suggestionsShown = false;
  }

  function bindEvents() {
    var btn = document.getElementById('bongio-chat-btn');
    var input = document.getElementById('bongio-input');
    var send = document.getElementById('bongio-send');

    btn.addEventListener('click', togglePanel);

    send.addEventListener('click', function () {
      var msg = input.value.trim();
      if (msg) sendMessage(msg);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        var msg = input.value.trim();
        if (msg) sendMessage(msg);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) togglePanel();
    });
  }

  function togglePanel() {
    var panel = document.getElementById('bongio-chat-panel');
    var btn = document.getElementById('bongio-chat-btn');
    isOpen = !isOpen;

    if (isOpen) {
      panel.classList.add('open');
      btn.classList.add('active');
      document.getElementById('bongio-input').focus();
    } else {
      panel.classList.remove('open');
      btn.classList.remove('active');
    }
  }

  function addMessage(role, text, sources) {
    var container = document.getElementById('bongio-messages');
    var typing = document.getElementById('bongio-typing');

    var msgDiv = document.createElement('div');
    msgDiv.className = 'bongio-msg ' + (role === 'user' ? 'bongio-msg-user' : 'bongio-msg-bot');

    var contentDiv = document.createElement('div');
    contentDiv.innerHTML = formatText(text);
    msgDiv.appendChild(contentDiv);

    if (sources && sources.length > 0) {
      var srcDiv = document.createElement('div');
      srcDiv.className = 'bongio-msg-sources';
      srcDiv.textContent = sources.map(function (s) { return '[Fonte: ' + s.label + ']'; }).join(' ');
      msgDiv.appendChild(srcDiv);
    }

    var timeDiv = document.createElement('div');
    timeDiv.className = 'bongio-msg-time';
    timeDiv.textContent = timeStr();
    msgDiv.appendChild(timeDiv);

    container.insertBefore(msgDiv, typing);
    scrollToBottom();

    return contentDiv;
  }

  function formatText(text) {
    return esc(text)
      .replace(/\n/g, '<br>');
  }

  function showTyping() {
    var el = document.getElementById('bongio-typing');
    if (el) el.classList.add('visible');
    scrollToBottom();
  }

  function hideTyping() {
    var el = document.getElementById('bongio-typing');
    if (el) el.classList.remove('visible');
  }

  function scrollToBottom() {
    var el = document.getElementById('bongio-messages');
    if (el) el.scrollTop = el.scrollHeight;
  }

  function showError(msg) {
    var container = document.getElementById('bongio-messages');
    var typing = document.getElementById('bongio-typing');
    var errDiv = document.createElement('div');
    errDiv.className = 'bongio-error';
    errDiv.textContent = msg || 'Si è verificato un errore. Riprova tra qualche istante.';
    container.insertBefore(errDiv, typing);
    scrollToBottom();
  }

  function sendMessage(text) {
    if (isSending || !text.trim()) return;
    isSending = true;
    hideSuggestions();

    var input = document.getElementById('bongio-input');
    var sendBtn = document.getElementById('bongio-send');
    input.value = '';
    sendBtn.disabled = true;

    addMessage('user', text);
    history.push({ role: 'user', content: text });

    showTyping();

    var body = JSON.stringify({
      message: text,
      history: history.slice(-20),
      isAgent: isAgent,
      identityToken: identityToken || undefined,
      currentProductHandle: currentProductHandle || undefined,
      currentCollectionHandle: currentCollectionHandle || undefined
    });

    fetch(API_URL + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        // Check if cached (non-streaming JSON response)
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') !== -1) {
          return response.json().then(function (data) {
            hideTyping();
            addMessage('bot', data.text, data.sources);
            history.push({ role: 'assistant', content: data.text });
            isSending = false;
            sendBtn.disabled = false;
          });
        }

        // SSE streaming response
        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';
        var fullText = '';
        var botContentEl = null;
        var firstTokenReceived = false;

        function processChunk(result) {
          if (result.done) {
            isSending = false;
            sendBtn.disabled = false;
            return;
          }

          buffer += decoder.decode(result.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
            if (!line.startsWith('data: ')) continue;

            var jsonStr = line.slice(6);
            try {
              var data = JSON.parse(jsonStr);
            } catch (e) {
              continue;
            }

            if (data.error) {
              hideTyping();
              showError(data.error);
              isSending = false;
              sendBtn.disabled = false;
              return;
            }

            if (data.token) {
              if (!firstTokenReceived) {
                hideTyping();
                botContentEl = addMessage('bot', '');
                firstTokenReceived = true;
              }
              fullText += data.token;
              if (botContentEl) {
                botContentEl.innerHTML = formatText(fullText);
              }
              scrollToBottom();
            }

            if (data.done) {
              history.push({ role: 'assistant', content: fullText });

              if (data.sources && data.sources.length > 0 && botContentEl) {
                var srcDiv = document.createElement('div');
                srcDiv.className = 'bongio-msg-sources';
                srcDiv.textContent = data.sources.map(function (s) { return '[Fonte: ' + s.label + ']'; }).join(' ');
                botContentEl.parentElement.appendChild(srcDiv);
              }

              isSending = false;
              sendBtn.disabled = false;
              return;
            }
          }

          return reader.read().then(processChunk);
        }

        return reader.read().then(processChunk);
      })
      .catch(function (err) {
        console.error('[bongio-chat] error:', err);
        hideTyping();
        showError();
        isSending = false;
        sendBtn.disabled = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
